import { render, staticRenderFns } from "./SchoolStaffLeaveApplicationControl.vue?vue&type=template&id=42d01604&scoped=true&"
import script from "./SchoolStaffLeaveApplicationControl.vue?vue&type=script&lang=js&"
export * from "./SchoolStaffLeaveApplicationControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d01604",
  null
  
)

export default component.exports